import Vue from 'vue'

const emailRE = /^[a-z0-9_\-.]+@[a-z0-9_\-.]+\.[a-z]{2,6}$/i

export default {
  strict: true,

  state: {
    email: '',
    subject: '',
    message: '',
    contactState: ''
  },

  mutations: {
    SET_CONTACT_EMAIL (state, email) {
      state.email = email
    },
    SEC_CONTACT_SUBJECT (state, subject) {
      state.subject = subject
    },
    SET_CONTACT_MESSAGE (state, message) {
      state.message = message
    },
    SET_CONTACT_STATE (state, contactState) {
      state.contactState = contactState
    }
  },

  actions: {
    setContactEmail ({ commit }, email) {
      commit('SET_CONTACT_EMAIL', email)
    },

    setContactSubject ({ commit }, subject) {
      commit('SEC_CONTACT_SUBJECT', subject)
    },

    setContactMessage ({ commit }, message) {
      commit('SET_CONTACT_MESSAGE', message)
    },

    sendMessage ({ commit, state, getters }) {
      let payload = {
        email: state.email,
        subject: state.subject,
        message: state.message
      }

      return Vue.http.post(process.env.API_URL + '/contact', payload)
    },

    setContactState ({ commit }, contactState) {
      commit('SET_CONTACT_STATE', contactState)
    }
  },

  getters: {
    contactEmail (state) { return state.email },
    contactEmailIsValid (state) { return emailRE.test(state.email) },
    contactSubject (state) { return state.subject },
    contactSubjectIsEmpty (state) { return state.subject === '' },
    contactMessage (state) { return state.message },
    contactMessageIsEmpty (state) { return state.message === '' },
    contactState (state) { return state.contactState }
  }
}



// WEBPACK FOOTER //
// ./src/stores/contact.js